import { useHTTP, useHTTPQuery } from "@/lib/http";

export interface FindInCollectionsResponseModel {
	readonly collectionId: string;
	readonly collectionName: string;
	readonly collectionImage: number;
	readonly variantId: string;
	readonly variantName: string;
	readonly quantity: number;
}

export const useFindInCollections = (productId: string) => {
	const http = useHTTP("Required");
	return useHTTPQuery({
		queryKey: ["findInCollections", productId],
		queryFn: () => http<FindInCollectionsResponseModel[]>({
			method: "GET",
			url: `/product/${productId}/find-in-collections`
		})
	});
};
